import Home from '@/views/Home'
import Listado from '@/views/Autorizaciones/Listado'

import { defineRoute, defineActionRoute, NotFound } from '@colescba/ui'

export default [
  defineRoute(
    {
      path: '/',
      name: 'Home',
      component: Home,
      props: true,
    },
    { text: 'Inicio' },
    {
      svg: 'OutlineHomeIcon',
      classes: 'w-7 h-7 text-colescba-blue-700 group-hover:text-colescba-blue-800',
    },
    true, // isNavigationLink,
    true, // isHamburgerLink,
  ),

  defineRoute(
    {
      path: '/solicitudes/',
      name: 'ListadoAutorizaciones',
      component: Listado,
      props: true,
    },
    { text: 'Solicitudes' },
    {
      svg: 'OutlineCollectionIcon',
      classes: 'w-7 h-7 text-colescba-blue-700 group-hover:text-colescba-blue-800',
    },
    true, // isNavigationLink,
    true, // isHamburgerLink,
    {
      header: {
        text: 'Listado de solicitudes',
      },
    },
  ),

  defineRoute(
    {
      path: '/autorizaciones/nueva',
      name: 'NuevaAutorizacion',
      component: () => import('@/views/Autorizaciones/Nueva'),
      props: true,
    },
    { text: 'Nueva autorización' },
    {
      svg: 'OutlinePLusCircleIcon',
      classes: 'w-7 h-7 text-colescba-blue-700 group-hover:text-colescba-blue-800',
    },
    true, // isNavigationLink,
    true, // isHamburgerLink,
    {
      header: {
        text: 'Nueva autorización',
      },
    },
  ),

  defineRoute(
    {
      path: '/autorizaciones/:solicitud_id',
      name: 'VerAutorizacion',
      component: () => import('@/views/Autorizaciones/Ver'),
      props: true,
    },
    { text: '' },
    null, // icono
    false, // isNavigationLink,
    false, // isHamburgerLink,
  ),

  defineRoute(
    {
      path: '/autorizaciones/:solicitud_id/editar',
      name: 'EditarAutorizacion',
      component: () => import('@/views/Autorizaciones/Editar'),
      props: true,
    },
    { text: '' },
    null, // icono
    false, // isNavigationLink,
    false, // isHamburgerLink,
  ),
  defineRoute(
    {
      path: '/revocatoria/nueva',
      name: 'NuevaRevocatoria',
      component: () => import('@/views/Revocatorias/Nueva'),
      props: true,
    },
    { text: 'Revocatoria' },
    {
      svg: 'OutlineXCircleIcon',
      classes: 'w-7 h-7 text-red-700 group-hover:text-red-800',
    },
    true, // isNavigationLink,
    true, // isHamburgerLink,
    {
      header: {
        text: 'Nueva revocatoria',
      },
    },
  ),
  defineRoute(
    {
      path: '/solicitud/:solicitudId/presentar',
      name: 'Presentar',
      component: () => import('@/views/Presentaciones/Presentar'),
      props: true,
    },
    { text: '' },
    null,
    false, // isNavigationLink,
    false, // isHamburgerLink,
  ),

  // siempre al final esta ruta
  defineRoute(
    {
      path: '*',
      name: 'NotFound',
      props: true,
      component: NotFound,
    },
    { text: '' },
    null, // icono
    false, // isNavigationLink,
    false, // isHamburgerLink,
  ),
]
